export const FEATURE_NAME = '@zerops/zerops/feature/pipeline-detail-dialog';
